"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationClientRedirecter = void 0;
/**
 * What is exposed by api-client is effectively abstract.
 *
 * In our tests, we have an implementation that makes https requests to look at location header / responses
 * and allows us to make assertions.
 *
 * In the app, we have a version that does a real redirect, changing the location of the page.
 */
var AuthenticationClientRedirecter = /** @class */ (function () {
    function AuthenticationClientRedirecter() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.redirect = function (url) {
            throw new Error('Not implemented. AuthenticationClientRedirecter must be overridden either for the browser, or for tests');
        };
    }
    return AuthenticationClientRedirecter;
}());
exports.AuthenticationClientRedirecter = AuthenticationClientRedirecter;
//# sourceMappingURL=AuthenticationClientRedirecter.js.map